import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import ContactSection from '@/pages/home/components/ContactSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FAQSection from '@/pages/home/components/FAQSection';
import AboutSection from '@/pages/home/components/AboutSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import AppSection from '@/pages/home/components/AppSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CarouselSection />
        <TopicsSection />
        <FAQSection />
        <AboutSection />
        <UpdatesSection />
        <CardsSection />
        <AppSection />
        <RankingSection />
        <CommentsSection />
        <IndexSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}